export default __webpack_public_path__ + "static/media/forgot-password.1eef0844.png";